import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ExecuteRequest } from 'core/glambox/GlamboxApi';
import { GlamboxEndpoints } from 'core/glambox/GlamboxEndpoints';
import { UiActions } from 'state/actions/UiActions';
import classname from 'classnames';
import Styles from './TrocaDePlano.module.scss';
import { Utils } from 'utils/Utils';

class SubscriptionTypeChange extends Component {
  constructor(props) {
    super(props);

    this.state = {
      validationMessage: '',
      currentPlanType: this.props.selectedPlanType || props.subscriptionInfo.subscriptionTypeId, //props.subscriptionInfo.subscriptionTypeId,
      newPlanType: null,
      couponName: null,
      subscriptionInfo: props.subscriptionInfo,
      subscriptionTypesInfo: null,
      subscriptionId: 1,
    };
    this.schedulePlanChange = this.schedulePlanChange.bind(this);
  }

  componentDidMount() {
    this.getSubscriptionTypesInfo();
  }

  getSubscriptionTypesInfo = () => {
    ExecuteRequest(
      GlamboxEndpoints.Open.subscriptionList,
      null,
      'GET',
      {
        Authorization: this.props.token.Authorization,
      },
      {
        id: this.state.subscriptionId,
      },
      (response) => {
        const { result, statusCode } = response;

        if (statusCode === 200) {
          let newPlanId;

          for (let n = 0; n < result.length; n++) {
            if (result[n].subscriptionTypeId > 1) {
              newPlanId = result[n].subscriptionTypeId;
              break;
            }
          }

          this.setState({
            newPlanType: newPlanId,
            currentPlanType: newPlanId,
            subscriptionTypesInfo: result,
          });
        } else {
          // TODO
        }
      }
      // "GET"
      // Object.assign({},
      //   {
      //     subscriber_id: this.state.subscriptionInfo.subscriberId,
      //     access_token: token,
      //     subscriptionId: this.state.subscriptionId
      //   }),
      // (result, error) => {
      //   if (result.resultType === "SUCCESS") {
      //     this.setState({ subscriptionTypesInfo: result.result });
      //   } else {
      //     //TODOa
      //   }
      // }
    );
  };

  showValidationMessage() {
    const validationMessage = this.state.validationMessage;
    return <h3>{validationMessage}</h3>;
  }

  renderAvailablePlanTypes = () => {
    let availablePlanTypesToSelect = this.state.subscriptionTypesInfo;

    if (!availablePlanTypesToSelect) return null;

    return availablePlanTypesToSelect.map((item, key) => {
      if (item == null || item.subscriptionTypeId === 1) return null;

      let _cls = [Styles['checked-option']];
      if (
        item.subscriptionTypeId === this.state.newPlanType ||
        item.subscriptionTypeId === this.state.currentPlanType
      ) {
        _cls.push(Styles['checked-option__selected']);
      }

      return (
        <label key={key} className={classname(_cls)}>
          <input
            type={'radio'}
            onChange={(e) => this.setNewPlanType(item.subscriptionTypeId)}
            checked={
              this.state.newPlanType === null
                ? item.subscriptionTypeId === this.state.currentPlanType
                : item.subscriptionTypeId === this.state.newPlanType
            }
            style={{ display: 'none' }}
          />

          <strong>{item.name}</strong>
          <span className={Styles['parcelas']}>
            {item.recurrenceMonths}x<b>{Utils.toCurrency(item.price / item.recurrenceMonths)}</b>
          </span>
          <span>Total: {Utils.toCurrency(item.price)}</span>
          <small>{item.summary}</small>
        </label>
      );
    });
  };

  setNewPlanType = (newPlanType) => {
    this.setState({ newPlanType: newPlanType, currentPlanType: newPlanType });
  };

  schedulePlanChange(event) {
    event.preventDefault();

    let { subscriptions } = this.props.subscriptionInfo;
    let { subs } = this.props.person;
    let { currentTarget } = event;
    let couponName = currentTarget.couponName.value;

    ExecuteRequest(
      GlamboxEndpoints.Subscriber.changePlan,
      Object.assign(
        {},
        {
          subscriptionTypeId: this.state.newPlanType,
          subscriberId: this.state.subscriptionInfo.id,
          couponName: couponName || null,
        }
      ),
      'POST',
      {
        Authorization: this.props.token.Authorization,
      },
      null,
      (response) => {
        const { result, statusCode } = response;

        if (statusCode === 200) {
          let dataLayerEvent = {
            nome_etapa: 'finalizacao_retencao',
            event: 'retencao',
            transactionId: 'retencao' + result.subscriberId,
            transactionAffiliation: 'Glambox',
            transactionTotal:
              result.discountValue !== null
                ? result.newPrice - result.discountValue
                : result.newPrice,
            transactionShipping: 0,
            transactionDiscount: result.discountValue || 0,
            transactionCoupon: couponName,
            transactionTax: 0,
            transactionProducts: [
              {
                sku: 'retencao' + result.newSubscriptionTypeId,
                name: 'retencao' + result.newSubscriptionTypeId,
                category: 'retencao',
                price: result.newPrice,
                quantity: 1,
              },
            ],
          };

          // window.dataLayer = window.dataLayer || [];
          // window.dataLayer.push(dataLayerEvent);

          this.setState({ planInfo: result });
          this.props.callback('changed');
          this.props.successAlert(
            result && result.message ? result.message : 'Plano alterado com sucesso.'
          );
          this.props.parentPlanChange(this.state.newPlanType);
          this.props.onCloseModal();
        } else {
          this.props.errorAlert(
            result && result.message
              ? result.message
              : 'Não foi possível realizar a troca de plano.'
          );
        }
      }
      // (response, error) => {
      //   const {
      //     result,
      //     resultType,
      //     message
      //   } = response;

      //   if (resultType === "SUCCESS") {
      //     let dataLayerEvent = {
      //       nome_etapa: "finalizacao_retencao",
      //       event: "retencao",
      //       transactionId: "retencao" + result.subscriberId,
      //       transactionAffiliation: "Glambox",
      //       transactionTotal: (result.discountValue !== null)
      //         ? result.newPrice - result.discountValue
      //         : result.newPrice,
      //       transactionShipping: 0,
      //       transactionDiscount: result.discountValue || 0,
      //       transactionCoupon: couponName,
      //       transactionTax: 0,
      //       transactionProducts: [{
      //         sku: "retencao" + result.newSubscriptionTypeId,
      //         name: "retencao" + result.newSubscriptionTypeId,
      //         category: "retencao",
      //         price: result.newPrice,
      //         quantity: 1
      //       }]
      //     };

      //     // window.dataLayer = window.dataLayer || [];
      //     // window.dataLayer.push(dataLayerEvent);

      //     this.setState({planInfo: result});
      //     this.props.callback('changed');
      //     this.props.successAlert(message);
      //     this.props.parentPlanChange(this.state.newPlanType);
      //     this.props.onCloseModal();
      //   } else {
      //     this.props.errorAlert(message || result);
      //   }
      // }
    );
  }

  render() {
    if (!this.state.subscriptionTypesInfo) return null;

    let showPlan = '';

    // let showPlan =
    //   this.props.subscriptionInfo.subscriptionTypeId === 1
    //     ? 'Mensal'
    //     : this.props.subscriptionInfo.subscriptionTypeId === 2
    //     ? 'Anual'
    //     : 'Semestral';
    // let showPlan = ''
    let planChange =
      this.props.subscriptionInfo.subscriptionTypeId === 1
        ? 'Semestral ou Anual'
        : this.props.subscriptionInfo.subscriptionTypeId === 2
        ? 'Semestral'
        : 'Anual';

    switch (this.props.subscriptionInfo.subscriptionTypeId) {
      case 1:
        showPlan = 'mensal';
        break;
      case 3:
        showPlan = 'semestral';
        break;
      default:
        showPlan = 'anual';
    }

    return (
      <div className={'form-group'}>
        <form onSubmit={this.schedulePlanChange}>
          <p>
            A sua assinatura ativa é <strong>assinatura {showPlan}</strong>! Mas você pode trocar
            pela assinatura <strong>{planChange}</strong>, basta selecionar e agendar.
          </p>
          <div className={Styles['plans-options']}>{this.renderAvailablePlanTypes()}</div>
          <input
            id={'couponName'}
            className={'form-control'}
            placeholder={'Insira um cupom de desconto'}
            type="text"
          />
          <input
            type={'submit'}
            className={'form-control'}
            value={'Agendar troca de plano'}
            id={'changePlan'}
          />
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.token.data,
    person: state.person.data,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    successAlert: (message) => {
      dispatch(UiActions.publishSuccessAlert(message));
    },
    errorAlert: (message) => {
      dispatch(UiActions.publishErrorAlert(message));
    },
  };
};

SubscriptionTypeChange = connect(mapStateToProps, mapDispatchToProps)(SubscriptionTypeChange);

export { SubscriptionTypeChange };
